export default class labExpertFinder {
  constructor(el) {
    this.el = el;
    this.finderSelectContainer = this.el.querySelector('[data-finder-select-container]');
    this.finderResultContainer = this.el.querySelector('[data-finder-result-container]');
    this.finderSelect = this.el.querySelector('[data-finder-select]');
    this.finderResults = this.finderResultContainer.querySelectorAll('[data-finder-result]');
    this.finderSubmitButton = this.el.querySelector('[data-finder-submit-button]');
    this.finderReset = this.el.querySelector('[data-finder-reset]');
    this.init();
  }

  init() {
    this.addFinderSubmitButtonListener();
    this.addFinderResetButtonListener();
  }

  addFinderSubmitButtonListener() {
    this.finderSubmitButton.addEventListener('click', () => {
      // if the "Select" option placeholder is selected
      if (this.finderSelect.selectedIndex === 0) {
        return;
      }

      this.toggleContainers();
      this.showResultBox();
    });
  }

  addFinderResetButtonListener() {
    this.finderReset.addEventListener('click', () => {
      this.toggleContainers();
      this.finderSelect.value = 'default';

      for (let i = 0; i < this.finderResults.length; i++) {
        this.finderResults[i].classList.add('hidden');
      }
    });
  }

  showResultBox() {
    const selectedOption = this.finderSelect.options[this.finderSelect.selectedIndex];
    const selectedOptionValue = selectedOption.getAttribute('value');
    this.finderResultContainer.querySelector(`[data-finder-result="${selectedOptionValue}"]`).classList.remove('hidden');
  }

  toggleContainers() {
    this.finderSelectContainer.classList.toggle('hidden');
    this.finderResultContainer.classList.toggle('hidden');
  }
}
